/**
 * Mobilmenyn.
 *
 * Byggd som egen markup med eget skript, inte på core/navigation:s överlägg.
 * Skälet är mätt, inte principiellt — tre krav i facitet (Navigation.html) går
 * inte att uppfylla med kärnans överlägg:
 *
 *   1. Undermenyn ska klickas fram. Kärnans interaktivitets-API binder
 *      aria-expanded till sitt eget tillstånd och håller undermenyer öppna i
 *      mobilläget. Knappen byter inte attribut vid klick.
 *   2. Krysset ska ligga i sidhuvudets rad. Kärnan lämnar en identitets-
 *      transform på överlägget, vilket gör det till en containing block, så
 *      position: fixed fäster i överlägget i stället för i fönstret.
 *   3. Telefonraden ska ligga fast i botten medan listan rullar. Kärnans
 *      __responsive-dialog tar inte emot en flexkedja utan att listan
 *      kollapsar.
 *
 * Designbriefen föreskriver dessutom att menyn byggs i sidhuvudets
 * template-part, inte som ett mönster.
 *
 * Listan KLONAS från navigationsblocket vid öppning. Det betyder att klienten
 * har EN meny att redigera — den i navigationsblocket — och att kopian aldrig
 * kan glida isär från den.
 */
( function () {
	var BRYT = 959; // samma brytpunkt som stilmallens mobilläge

	function init() {
		var oppna  = document.querySelector( '.bm-mobilmeny__oppna .wp-block-button__link' );
		var meny   = document.getElementById( 'bm-mobilmeny' );
		var stang  = meny && meny.querySelector( '.bm-mobilmeny__stang .wp-block-button__link' );
		var lista  = meny && meny.querySelector( '.bm-mobilmeny__lista' );
		var kalla  = document.querySelector( '.bm-nav .wp-block-navigation__container' );
		if ( ! oppna || ! meny || ! stang || ! lista || ! kalla ) { return; }

		oppna.setAttribute( 'role', 'button' );
		oppna.setAttribute( 'aria-controls', 'bm-mobilmeny' );
		oppna.setAttribute( 'aria-expanded', 'false' );
		stang.setAttribute( 'role', 'button' );
		stang.setAttribute( 'aria-controls', 'bm-mobilmeny' );
		meny.hidden = true;

		/**
		 * Kopiera navigationsblockets lista och gör om den till menyns form:
		 * undermenyer får en egen knapp som fäller ut, resten blir vanliga rader.
		 */
		function bygg() {
			lista.textContent = '';
			var ul = kalla.cloneNode( true );
			// Kärnans egna klasser och interaktivitetsattribut följer inte med —
			// de bär beteende vi nu äger själva.
			ul.querySelectorAll( '*' ).forEach( function ( el ) {
				Array.prototype.slice.call( el.attributes ).forEach( function ( a ) {
					if ( a.name.indexOf( 'data-wp-' ) === 0 ) { el.removeAttribute( a.name ); }
				} );
			} );
			ul.className = 'bm-mobilmeny__nav';
			ul.querySelectorAll( 'li' ).forEach( function ( li ) {
				var under = li.querySelector( 'ul' );
				li.className = under ? 'bm-mobilmeny__post bm-mobilmeny__post--grupp' : 'bm-mobilmeny__post';
				if ( under ) { under.className = 'bm-mobilmeny__under'; }
				li.querySelectorAll( 'a' ).forEach( function ( a ) {
					a.className = a.closest( 'ul' ) === ul ? 'bm-mobilmeny__topp' : 'bm-mobilmeny__lank';
				} );
				// Kärnan renderar undermenyns rubrik som en knapp utan href.
				// Den blir en riktig länk här, så Verkstad går att nå direkt,
				// och utfällningen får en egen knapp bredvid.
				var rubrik = li.querySelector( 'button' );
				if ( rubrik ) {
					var a = document.createElement( 'a' );
					a.className = 'bm-mobilmeny__topp';
					a.textContent = rubrik.textContent.trim();
					a.href = ( under && under.querySelector( 'a' ) ) ? under.querySelector( 'a' ).href : '#';
					rubrik.replaceWith( a );
				}
			} );
			// Utfällningsknappar, en per grupp.
			ul.querySelectorAll( '.bm-mobilmeny__post--grupp' ).forEach( function ( li, i ) {
				var under = li.querySelector( '.bm-mobilmeny__under' );
				var id = 'bm-under-' + i;
				under.id = id;
				var knapp = document.createElement( 'button' );
				knapp.type = 'button';
				knapp.className = 'bm-mobilmeny__fall';
				knapp.setAttribute( 'aria-controls', id );
				// Brädan ritar Verkstad utfälld, men menyn ska öppna hopfälld:
				// en meny som redan visar en utfälld gren döljer sina egna
				// toppnivåer. Medveten avvikelse, noterad i
				// MANUS-ANDRINGSLOGG.md.
				var oppen = false;
				knapp.setAttribute( 'aria-expanded', String( oppen ) );
				knapp.setAttribute( 'aria-label', 'Visa undermeny för ' + li.querySelector( '.bm-mobilmeny__topp' ).textContent.trim() );
				under.hidden = ! oppen;
				li.querySelector( '.bm-mobilmeny__topp' ).after( knapp );
				knapp.addEventListener( 'click', function () {
					var nu = knapp.getAttribute( 'aria-expanded' ) === 'true';
					knapp.setAttribute( 'aria-expanded', String( ! nu ) );
					under.hidden = nu;
				} );
			} );
			lista.appendChild( ul );
		}

		var sistFokus = null;

		function fokuserbara() {
			return Array.prototype.filter.call(
				meny.querySelectorAll( 'a[href], button:not([disabled])' ),
				function ( el ) { return el.offsetParent !== null; }
			);
		}

		function oppnaMeny( e ) {
			if ( e ) { e.preventDefault(); }
			sistFokus = document.activeElement;
			bygg();
			meny.hidden = false;
			document.documentElement.classList.add( 'bm-meny-oppen' );
			oppna.setAttribute( 'aria-expanded', 'true' );
			var f = fokuserbara();
			if ( f[ 0 ] ) { f[ 0 ].focus(); }
		}

		function stangMeny( e ) {
			if ( e ) { e.preventDefault(); }
			meny.hidden = true;
			document.documentElement.classList.remove( 'bm-meny-oppen' );
			oppna.setAttribute( 'aria-expanded', 'false' );
			// Fokus tillbaka till hamburgaren, som facitet kräver.
			if ( sistFokus && sistFokus.focus ) { sistFokus.focus(); }
		}

		oppna.addEventListener( 'click', oppnaMeny );
		stang.addEventListener( 'click', stangMeny );

		// Stängs vid navigering: en länk i menyn lämnar sidan ändå, men på en
		// ankarlänk gör den det inte, och då ska menyn inte ligga kvar.
		meny.addEventListener( 'click', function ( e ) {
			var a = e.target.closest( 'a' );
			if ( a && ! a.closest( '.bm-mobilmeny__stangrad' ) ) { stangMeny(); }
		} );

		document.addEventListener( 'keydown', function ( e ) {
			if ( meny.hidden ) { return; }
			if ( e.key === 'Escape' ) { stangMeny(); return; }
			if ( e.key !== 'Tab' ) { return; }
			// Fokus hålls kvar i menyn medan den är öppen.
			var f = fokuserbara();
			if ( ! f.length ) { return; }
			var forst = f[ 0 ], sist = f[ f.length - 1 ];
			if ( e.shiftKey && document.activeElement === forst ) { e.preventDefault(); sist.focus(); }
			else if ( ! e.shiftKey && document.activeElement === sist ) { e.preventDefault(); forst.focus(); }
		} );

		// Om fönstret växer förbi brytpunkten är menyn inte längre rätt läge.
		window.addEventListener( 'resize', function () {
			if ( ! meny.hidden && window.innerWidth > BRYT ) { stangMeny(); }
		} );
	}

	if ( document.readyState === 'loading' ) {
		document.addEventListener( 'DOMContentLoaded', init );
	} else {
		init();
	}
}() );
